import React, { useState, useEffect } from 'react';
import { Card, Tag, Spin, Alert } from 'antd';
import {instance} from "../../../API/API";


const TotalObjectsCard = () => {
    const [data, setData] = useState({ current: 0, previous: 0 });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchObjectsData();
    }, []);

    const fetchObjectsData = async () => {
        try {
            setLoading(true);
            const response = await instance.get('analytics/total_objects.php');

            if (response.data.success) {
                setData({
                    current: response.data.data.current_year,
                    previous: response.data.data.previous_year
                });
            } else {
                throw new Error('Invalid response format');
            }
        } catch (err) {
            console.error('Error fetching objects data:', err);
            setError('Ошибка загрузки данных об объектах');
        } finally {
            setLoading(false);
        }
    };

    const calculateDifference = (current, previous) => {
        if (previous === 0) return current > 0 ? 100 : 0;
        return ((current - previous) / previous) * 100;
    };

    const getDifferenceColor = (difference) => {
        return difference >= 0 ? '#52c41a' : '#ff4d4f';
    };

    const getDifferenceIcon = (difference) => {
        return difference >= 0 ? '↗' : '↘';
    };

    if (loading) {
        return (
            <Card style={{
                height: '140px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Spin />
            </Card>
        );
    }

    if (error) {
        return (
            <Card style={{ height: '140px' }}>
                <Alert message={error} type="error" />
            </Card>
        );
    }

    const diff = calculateDifference(data.current, data.previous);

    return (
        <Card style={{
            height: '140px',
            background: 'white',
            border: '1px solid #f0f0f0',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}
              bodyStyle={{
                  padding: '16px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
              }}>
            <div style={{ color: '#595959', fontSize: '14px', fontWeight: '500' }}>
                Посещено объектов
            </div>
            <div style={{ color: '#1890ff', fontSize: '28px', fontWeight: '600' }}>
                {data.current}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: '#8c8c8c', fontSize: '12px' }}>
                    Прошлый год: {data.previous}
                </span>
                <Tag style={{
                    background: getDifferenceColor(diff),
                    border: 'none',
                    color: 'white',
                    fontSize: '11px',
                    margin: 0
                }}>
                    {getDifferenceIcon(diff)} {diff.toFixed(1)}%
                </Tag>
            </div>
        </Card>
    );
};

export default TotalObjectsCard;